module.exports = __webpack_public_path__ + "img/list-pattern1.f934e4c.svg";